/**
 * Created by henian.xu on 2018/7/19.
 *
 */

import CmsCatalog from './CmsCatalog';
import CmsArticle from './CmsArticle';
import CmsArticleComment from './CmsArticleComment';
import PortalInfoConfig from './PortalInfoConfig';

export default {
    CmsCatalog,
    CmsArticle,
    CmsArticleComment,
    PortalInfoConfig,
};
